const headerItems = document.querySelectorAll('[data-linknumber]');
const menuItems = document.querySelectorAll('.menu-item');
const mainheader = document.querySelectorAll('.mid-section');

headerItems.forEach((item) => {
  item.addEventListener('mouseenter', () => {
    var number = item.getAttribute('data-linknumber'); 
    var identitySelect = '[data-linklistener-' + number.toString() + ']'; 
    var target = document.querySelector(identitySelect);
    var menus = document.querySelectorAll('.menu-item');
    menus.forEach((item) => {
      item.classList.add('hide');
    })

    if(target != null ){
      target.classList.remove('hide');
    }
  })
  menuItems.forEach((item) => {
    item.addEventListener('mouseleave', () => {
      item.classList.add('hide')
    })
  })
  mainheader.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      menuItems.forEach((item) => {
        item.classList.add('hide');
      })
    })
  })
})

